<div class="">
    <div class="card-body p-0">
        <div>
            <table class="table w-100 align-middle">
                <thead class="custom-thead">
                <tr>
                    <th class="text-start">LABEL</th>
                    <th style="width: 120px; text-align: center;padding-right: 16px">ACTION</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="isLoading">
                    <td colspan="2" class="text-center">Chargement des marques...</td>
                </tr>
                <ng-container *ngIf="!isLoading">
                    <tr *ngFor="let marque of marques">
                        <td class="fw-medium">{{ marque.libelle }}</td>
                        <td class="text-start">
                            <button type="button"
                                    class="btn btn-primary btn-sm d-flex align-items-center justify-content-center mx-auto"
                                    style="width: 30px; height: 30px; padding: 0;"
                                    (click)="editMarque(marque)">
                                <i data-feather="edit" class="feather-icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="marques.length === 0">
                        <td colspan="2" class="text-center">Aucune marque trouvée. Ajoutez une marque pour commencer.</td>
                    </tr>
                </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
